var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section" },
    [
      _vm._l(_vm.addresses, function(address) {
        return _c("address-card", {
          key: address.id,
          attrs: {
            address: address,
            selected: _vm.selected && _vm.selected.id === address.id
          },
          on: {
            delete: _vm.deleteConfirmation,
            edit: _vm.showEdit,
            selected: _vm.setSelected
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "new-address", on: { click: _vm.showNewAddress } },
        [
          _c("div", { staticClass: "icon-plus" }, [_vm._v("+")]),
          _vm._v(" "),
          _c("span", [_vm._v("adicionar endereço")])
        ]
      ),
      _vm._v(" "),
      _vm.newAddress
        ? _c("new-address", {
            attrs: { accountable: _vm.accountable },
            on: {
              close: function($event) {
                _vm.newAddress = false
              },
              created: function($event) {
                return _vm.createdAddress($event)
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-431fb2cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431fb2cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Addresses/Index.vue
// module id = null
// module chunks = 